// reusable aliases for mutations
export const AUTH_MUTATIONS = {
  SET_USER: "SET_USER",
  SET_PAYLOAD: "SET_PAYLOAD",
  LOGOUT: "LOGOUT",
};

export const state = () => ({
  access_token: null, // JWT access token
  refresh_token: null, // JWT refresh token
  user: null,
});

export const mutations = {
  // store the logged in user in the state
  [AUTH_MUTATIONS.SET_USER](state, user) {
    state.user = user;
  },

  // store new or updated token fields in the state
  [AUTH_MUTATIONS.SET_PAYLOAD](state, { access_token, refresh_token = null }) {
    state.access_token = access_token;

    // refresh token is optional, only set it if present
    if (refresh_token) {
      state.refresh_token = refresh_token;
    }
  },

  // clear our the state, essentially logging out the user
  [AUTH_MUTATIONS.LOGOUT](state) {
    state.user = null;
    state.access_token = null;
    state.refresh_token = null;
  },
};

export const actions = {
  async fetchUser({ commit, state }, manualId = null) {
    const userId = manualId || state.user?.id || state.user?.pk;
    console.log(state, userId, "fetchUser::");
    if (!userId) return;

    try {
      const { data } = await this.$axios.get(`/api/users/${userId}/`);
      commit(AUTH_MUTATIONS.SET_USER, data);
      return data;
    } catch (err) {
      console.error("Error refreshing user data:", err);
    }
  },

  async login({ commit, dispatch }, { email_address, password }) {
    // make an API call to login the user with an email address and password
    const {
      data: {
        data: { user, payload },
      },
    } = await this.$axios.post("/auth/login", { email_address, password });

    // commit the user and tokens to the state
    // commit(AUTH_MUTATIONS.SET_USER, user);
    commit(AUTH_MUTATIONS.SET_PAYLOAD, payload);
    await dispatch("fetchUser");
  },

  async oauth({ commit, dispatch }, { user, payload }) {
    // make an API call to login the user with an email address and password
    // commit the user and tokens to the state

    console.log(user, "oauth::");
    // let userPermissions = user;
    // const { pk } = user;
    commit(AUTH_MUTATIONS.SET_PAYLOAD, payload);
    commit(AUTH_MUTATIONS.SET_USER, user);

    // if (pk) {
    //   const { data } = await this.$axios.get(`/api/users/${pk}/`);
    //   if (data) {
    //     userPermissions = data;
    //   }
    // }

    // commit(AUTH_MUTATIONS.SET_USER, userPermissions);
    await dispatch("fetchUser");
  },

  async register({ commit, dispatch }, { email_address, password }) {
    // make an API call to register the user
    const {
      data: {
        data: { user, payload },
      },
    } = await this.$axios.post("/auth/register", {
      email_address,
      password,
    });

    // commit the user and tokens to the state
    // commit(AUTH_MUTATIONS.SET_USER, user);
    commit(AUTH_MUTATIONS.SET_PAYLOAD, payload);
    await dispatch("fetchUser");
  },

  // given the current refresh token, refresh the user's access token to prevent expiry
  async refresh({ commit, state, dispatch }) {
    const { refresh_token } = state;

    // make an API call using the refresh token to generate a new access token

    try {
      const { data } = await this.$axios.request({
        url: "/auth/token/refresh/",
        method: "post",
        data: {
          refresh: refresh_token,
        },
      });

      if (data) {
        const { access } = data;

        const payload = { access_token: access, refresh_token };

        commit(AUTH_MUTATIONS.SET_PAYLOAD, payload);

        // Refresh the user profile to ensure subscription status is current
        await dispatch("fetchUser");

        // Update User in case of subscription expiration, default after 1hour, refresh will be called
        // let userPermissions = state.user;
        // const { id } = state.user;

        // if (id) {
        //   const { data: userData } = await this.$axios.get(`/api/users/${id}/`);

        //   if (userData) {
        //     // Update expiring user subscription
        //     const { subscriptions } = userData;
        //     userPermissions = userData;

        //     if (
        //       subscriptions &&
        //       subscriptions?.is_active &&
        //       subscriptions?.current_period_end &&
        //       !dayjs(subscriptions?.current_period_end).isAfter(dayjs())
        //     ) {
        //       await this.$axios.request({
        //         url: `/api/user/subscribe/${subscriptions.id}/`,
        //         method: 'put',
        //         data: {
        //           validate: 1,
        //         },
        //       });

        //       const { data: newUserData } = await this.$axios.get(
        //         `/api/users/${id}/`
        //       );

        //       userPermissions = newUserData;
        //     }
        //   }
        // }

        // commit(AUTH_MUTATIONS.SET_USER, userPermissions);
      }
    } catch (err) {
      console.log(err);
    }
  },

  // logout the user
  logout({ commit }) {
    commit(AUTH_MUTATIONS.LOGOUT);
  },
};

export const getters = {
  // determine if the user is authenticated based on the presence of the access token
  isSigned: (state) => {
    return state.access_token && state.access_token !== "";
  },
  // Helper to check Pro status easily in components
  isMembership: (state) => {
    const sub = state.user?.subscription;
    if (!sub) return false;
    return sub.status === "active" || sub.status === "canceled";
  },
};
